import { module } from "angular";
import employeesCore from "@gtmhub/employees/employees-core.module";
import errorHandling from "@gtmhub/error-handling/module";
import favorites from "@gtmhub/favorites/favorites.module";
import files from "@gtmhub/files/module";
import teamsCore from "@gtmhub/teams/teams-core.module";
import { ChangeUserPictureComponent } from "./components/change-user-picture/change-user-picture.component";
import { EditUserNamesCtrl } from "./components/edit-user-names/edit-user-names.component";
import { UserLicenseComponent } from "./components/user-license/user-license.component";
import { EditUserLicenseCtrl } from "./controllers/edit-user-license.ctrl";
import { UserDetailsViewCtrl } from "./controllers/user-details-view.ctrl";
import { UsersListCtrl } from "./controllers/users-list.ctrl";
import { MultiUserSelectorCtrl } from "./controllers/users-selector";
import usersCore from "./users-core.module";

const mod = module("users", [usersCore, files, errorHandling, employeesCore, teamsCore, favorites]);

mod.controller("EditUserNamesCtrl", EditUserNamesCtrl);
mod.controller("MultiUserSelectorCtrl", MultiUserSelectorCtrl);
mod.controller("UsersListCtrl", UsersListCtrl);
mod.controller("UserDetailsViewCtrl", UserDetailsViewCtrl);
mod.controller("EditUserLicenseCtrl", EditUserLicenseCtrl);

mod.component("changeUserPicture", ChangeUserPictureComponent);
mod.component("userLicense", UserLicenseComponent);

export default mod.name;
